module.exports = __webpack_public_path__ + "img/tristar-cargo-handling.36e85a59.jpg";